import { render } from "./Home.vue?vue&type=template&id=204418b6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=204418b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-204418b6"

export default script